/*
 * Copies the Kiwi Sizing chart into the "Size & Fit" accordion inside
 * <product-info>.
 *
 * Kiwi renders its chart asynchronously and injects it inside <product-info>
 * (hidden by macade-kiwi-sizing.css). When the colour picker swaps
 * <product-info> in place, that original is thrown away with the old section,
 * so the chart markup is remembered the first time it is seen and reused for
 * every later swap. Sibling products share the same chart.
 */
(function () {
  const POLL_MS = 500;
  const MAX_POLLS = 60;
  let chartHtml = null;

  function chartSource() {
    const charts = Array.from(document.querySelectorAll('.ks-chart-container'));
    return (
      charts.find((el) => !el.closest('.product__accordion')) ||
      charts[0] ||
      null
    );
  }

  function injectChart(root) {
    const source = chartSource();
    if (source) chartHtml = source.outerHTML;
    if (!chartHtml) return false;

    root.querySelectorAll('.product__accordion').forEach((accordion) => {
      const title = accordion.querySelector('.accordion__title');
      if (!title || title.textContent.trim() !== 'Size & Fit') return;
      const content = accordion.querySelector('.accordion__content');
      if (!content || content.querySelector('.ks-chart-container')) return;
      content.insertAdjacentHTML('beforeend', chartHtml);
    });
    return true;
  }

  function ensureChart(root) {
    if (injectChart(root)) return;
    let polls = 0;
    const intervalId = setInterval(() => {
      if (injectChart(root) || ++polls >= MAX_POLLS) clearInterval(intervalId);
    }, POLL_MS);
  }

  ensureChart(document);
  document.addEventListener('product-info:loaded', (event) => {
    ensureChart(event.target);
  });
})();
